const POSTAL_CODE_REGEX = /^[0-9]{5}$/

export class PostalCode {
  private _code: string

  constructor (code: string) {
    if (POSTAL_CODE_REGEX.test(code) === false) {
      throw new TypeError('Postal Code not valid')
    }
    this._code = code
  }

  code (): string {
    return this._code
  }
}
